import { useEffect, useLayoutEffect, useRef } from "react";

export function animationsPayloadKey(animations) {
    if (!animations) return "";
    return JSON.stringify(animations);
}

function buildKeyframesCss(animations) {
    return animations.reduce((accum, {animationName, keyframes}) => accum += `
        @keyframes ${animationName}{
            ${Object.entries(keyframes).reduce((accum, [step, obj]) => {
                return accum += `${step} {
                ${Object.entries(obj).reduce((props, [key, value]) => props += `${key}: ${value};\n`, '')}
                }`
            }, '')}
        }\n`, '');
}

function writeKeyframes(stylesheet, animations) {
    const css = animations ? buildKeyframesCss(animations) : "";
    if (typeof stylesheet.replaceSync === "function") {
        stylesheet.replaceSync(css);
        return;
    }
    stylesheet.replace(css);
}

function Keyframes({ animations, children }) {

    const keyframesStylesheetRef = useRef();
    const animationsRef = useRef(animations);
    animationsRef.current = animations;
    const animationsKey = animationsPayloadKey(animations);

    useLayoutEffect(() => {
        if (!keyframesStylesheetRef.current) {
            const stylesheet = new CSSStyleSheet();
            document.adoptedStyleSheets = [...document.adoptedStyleSheets, stylesheet];
            keyframesStylesheetRef.current = stylesheet;
        }
        writeKeyframes(keyframesStylesheetRef.current, animationsRef.current);
    }, [animationsKey]);

    useEffect(() => {
        return () => {
            const stylesheet = keyframesStylesheetRef.current;
            if (!stylesheet) return;
            document.adoptedStyleSheets = document.adoptedStyleSheets.filter (as => as !== stylesheet);
            keyframesStylesheetRef.current = null;
        };
    }, []);

    return ([children])
}

export default Keyframes;
